import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {loadingIndicatorAttrs} from 'notebook/util/ExportInstrumentation';
import getTestProps from 'test/lib/cypress/getTestProps';

export default function HorizontalThrobber(): JSX.Element {
  return (
    <div
      className={css(styles.horizontalThrobber)}
      {...loadingIndicatorAttrs()}
      {...getTestProps({component: 'HorizontalThrobber', element: 'root'})}
    >
      Loading...
    </div>
  );
}

interface CenteredHorizontalThrobberProps {
  suppressPadding?: boolean;
  className?: string;
}

export function CenteredHorizontalThrobber({
  suppressPadding = false,
  className,
}: CenteredHorizontalThrobberProps): JSX.Element {
  return (
    <div
      className={classNames(
        css(styles.centeringWrapper),
        {[css(styles.paddedWrapper)]: !suppressPadding},
        className
      )}
    >
      <HorizontalThrobber />
    </div>
  );
}

const THROBBER_WIDTH = 12;
const THROBBER_HEIGHT = 16;
const THROBBER_GAP = 16;

const keyframes = {
  '0%': {
    background: Color.GRAY_300,
  },
  '10%': {
    background: Color.GRAY_700,
  },
  '40%': {
    background: Color.GRAY_300,
  },
  '100%': {
    background: Color.GRAY_300,
  },
};

const styles = StyleSheet.create({
  horizontalThrobber: {
    animationName: [keyframes],
    animationDuration: '2000ms',
    animationDelay: '300ms',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-out',
    display: 'inline-block',
    position: 'relative',
    textIndent: '-9999px',
    width: THROBBER_WIDTH,
    height: THROBBER_HEIGHT,
    margin: `0 ${THROBBER_GAP}px`,
    '::before': {
      content: '""',
      display: 'inline-block',
      width: THROBBER_WIDTH,
      height: THROBBER_HEIGHT,
      position: 'absolute',
      top: 0,
      left: `-${THROBBER_GAP}px`,
      animationName: [keyframes],
      animationDuration: '2000ms',
      animationDelay: '150ms',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'ease-out',
    },
    '::after': {
      content: '""',
      display: 'inline-block',
      width: THROBBER_WIDTH,
      height: THROBBER_HEIGHT,
      position: 'absolute',
      top: 0,
      right: `-${THROBBER_GAP}px`,
      animationName: [keyframes],
      animationDuration: '2000ms',
      animationDelay: '450ms',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'ease-out',
    },
  },
  centeringWrapper: {
    textAlign: 'center',
  },
  paddedWrapper: {
    padding: '20px',
  },
});
